import React from 'react';

//helpers
import {styleable} from 'decorators';

//styled-components
import {StepNumber} from './styles';

export const StepNumberDesktop = styleable(({number}) => (
  <StepNumber className="stepNumber" device="desktop" data-cy="step-number">
    {number}
  </StepNumber>
));

export const StepNumberMobile = styleable(({number}) => (
  <StepNumber className="stepNumber" device="mobile" data-cy="step-number">
    {number}
  </StepNumber>
));
